module.exports = __webpack_public_path__ + "static/media/20200921_171750.6bf96c02.jpg";